import styled from 'styled-components';


export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px;
  width: 100%;
`;

export const UserAvatar = styled.div`
  display: flex;
  align-items: center;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SwitchContainer = styled.div`

`;

export const UserName = styled.span`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
`;

export const UserFilial = styled.span`
  font-size: 14px;
`;

export const Info = styled.div`
position:absolute;
  right:0
`;

export const HistoryContainer = styled.div`

  width: 100%;
  overflow:hidden
`;


export const HistoryHeader = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  overflow:hidden;
  height:60px;
  align-items: center;
`;


export const TextBase = styled.div`
  flex:1;
  text-align:center
`;

export const Text = styled(TextBase)`

`;